module.exports = __webpack_public_path__ + "static/media/plant.4d38c268.jpg";